import apiClientV2 from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_BFF_URL

export const transition = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order/transition`,
    data,
  })

  return response?.data
}
